import { Injectable, inject, signal, effect } from '@angular/core';
import { Firestore, doc, onSnapshot } from '@angular/fire/firestore';
import { Auth, authState } from '@angular/fire/auth';
import { UserStatus, RegistrationStatus } from '../models/user-status.model';

@Injectable({ providedIn: 'root' })
export class UserStatusService {
  private readonly firestore = inject(Firestore);
  private readonly auth = inject(Auth);

  readonly userStatus = signal<UserStatus | null>(null);
  readonly loading = signal(true);

  private unsubscribe: (() => void) | null = null;

  constructor() {
    authState(this.auth).subscribe((user) => {
      this.cleanup();
      if (user) {
        this.loading.set(true);
        const ref = doc(this.firestore, 'userStatus', user.uid);
        this.unsubscribe = onSnapshot(
          ref,
          (snap) => {
            this.userStatus.set(snap.exists() ? (snap.data() as UserStatus) : null);
            this.loading.set(false);
          },
          (error) => {
            console.error('Error reading userStatus:', error);
            this.loading.set(false);
          },
        );
      } else {
        this.userStatus.set(null);
        this.loading.set(false);
      }
    });
  }

  private cleanup(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  }
}
